import type { ISbStoryData } from '@storyblok/js'
import type { BannersCarousel, Page } from '@percent/cause-dashboard/storyblok/types/storyblok-components'

/**
 * Returns the first `banners_carousel` blok in `page.body` (by array order).
 * If multiple carousels exist, only the first is used.
 */
export function extractFirstBannersCarouselFromPageStory(story: ISbStoryData<Page>): BannersCarousel | null {
  const body = story.content.body ?? []

  return (
    body.find(
      (blok): blok is BannersCarousel =>
        typeof blok === 'object' && blok !== null && (blok as { component?: string }).component === 'banners_carousel'
    ) ?? null
  )
}
